export const buildMentionUsers = ({ users = [], teams = [], currentUser = null }) => {
  const unique = new Map();
  const emailsSeen = new Set();

  const register = (candidate) => {
    const email = String(candidate?.email || "").trim().toLowerCase();
    const userId = candidate?.id ? String(candidate.id) : "";
    if (!email || emailsSeen.has(email)) return;

    const dedupeKey = userId || email;
    if (unique.has(dedupeKey)) return;

    emailsSeen.add(email);
    unique.set(dedupeKey, {
      id: userId || email,
      display: email,
    });
  };

  users.forEach((user) => {
    const email =
      user?.email ||
      user?.emails?.[0]?.address ||
      "";
    register({
      id: user?.id,
      email,
    });
  });

  teams.forEach((team) => {
    (team?.members || []).forEach((member) => {
      register({
        id: member?.userId,
        email: member?.email,
      });
    });
  });

  if (currentUser?.email) {
    register({
      id: currentUser.id,
      email: currentUser.email,
    });
  }

  return Array.from(unique.values()).sort((a, b) => a.display.localeCompare(b.display));
};
